import { api } from "../../../apiAxios";
import { getToken } from "../../../LStorage/token";
import { urlHttpGov } from "../../../urls";

class CertidoesService {
    private readonly baseURL = `${urlHttpGov}/congelamento-cnpj/certidao`;

    async getCertidoes(signal?: AbortSignal) {

        const { data } = await api.get(`${this.baseURL}`,
            {
                headers: {
                    'Authorization': 'Bearer ' + getToken()
                },
                signal
            });

        return data
    }

    async getCertidoesById(id: number | string, signal?: AbortSignal) {

        const { data } = await api.get(`${this.baseURL}/${id}`,
            {
                headers: {
                    'Authorization': 'Bearer ' + getToken()
                },
                signal
            });

        return data
    }

    async postCertidoes(obj: any, signal?: AbortSignal) {

        const { data } = await api.post(`${this.baseURL}`,
            obj,
            {
                headers: {
                    'Authorization': 'Bearer ' + getToken()
                },
                signal
            });

        return data
    }

    async putCertidoes(id: number | string, obj: any, signal?: AbortSignal) {

        const { data } = await api.put(`${this.baseURL}/${id}`,
            obj,
            {
                headers: {
                    'Authorization': 'Bearer ' + getToken()
                },
                signal
            });

        return data
    }

    async deleteCertidoes(id: number | string, signal?: AbortSignal) {

        const { data } = await api.delete(`${this.baseURL}/${id}`,
            {
                headers: {
                    'Authorization': 'Bearer ' + getToken()
                },
                signal
            });

        return data
    }

}

// eslint-disable-next-line import/no-anonymous-default-export
export default new CertidoesService();
